module.exports = __webpack_public_path__ + "img/mcgl_xsbj_04.62cc14f9.png";